import React, {
  createContext, ReactNode, useCallback, useMemo, useState,
} from 'react';

export const ModalErrorContext = createContext( {
  showModal: false,
  description: '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openErrorModal: ( description: string ) => {},
  closeErrorModal: () => {},
} );

function ModalErrorProvider( { children }: { children: ReactNode } ) {
  const [showModal, setShowModal] = useState( false );
  const [description, setDescription] = useState( '' );

  const openErrorModal = useCallback( ( desc ) => {
    setDescription( desc );
    setShowModal( true );
  }, [] );

  const closeErrorModal = useCallback( () => {
    setDescription( '' );
    setShowModal( false );
  }, [] );

  const value = useMemo( () => ( {
    description,
    showModal,
    openErrorModal,
    closeErrorModal,
  } ), [showModal, description] );

  return (
    <ModalErrorContext.Provider value={value}>
      {children}
    </ModalErrorContext.Provider>
  );
}

export default ModalErrorProvider;
